const searchClient = algoliasearch(
    'A2HDJIN1DW',
    '47452381365eabfc80fc5b9fcf112597'
)

let siteHeader = document.getElementById('site-header');
let shopCurrency;
let shopLocator;
let shopLocale;
let headerColor = document.getElementById('site-header').getAttribute('data-color');

let magColor = document.getElementById('autocomplete').style.backgroundColor;

let archiveTagsJs = JSON.parse(archiveTagsLs);
let archiveTags = ''

archiveTagsJs.forEach(function(tag) {
  if (archiveTags === '') {
    archiveTags = 'NOT tags:' + tag;
  } else {
    archiveTags += ' AND NOT tags:' + tag;
  }
});

let isArchive = false;
if (document.getElementById('hits')){
  if(document.getElementById('hits').getAttribute('data-collection').includes('archive')){
    isArchive = true;
  }
}

let closeSearchPanel = (e) => {
  document.querySelector('.site-nav--search').classList.add('!hidden');
  document.querySelector('.site-nav--search-overlay').classList.add('!hidden');
  document.querySelector('.site-header').classList.remove('active', 'bg-white');
  document.querySelector('.site-header').style.color = headerColor;
  document.getElementById('AccessibleNav').classList.remove('bg-white')

  // if($(window).width() < 768){
  //   document.querySelector('.site-header').classList.remove('active', 'bg-white').style.color = headerColor;
  //   document.getElementById('AccessibleNav').classList.remove('bg-white')
  // }
}

let productItem = (html, item, components) => {
 return html`
    <a
      href="${window.Shopify.routes.root}products/${item.handle}${item.__queryID ? '?queryID='+item.__queryID : ''}" class="item text-center cursor-pointer hover:opacity-100 bg-white relative rounded-md h-full pt-6" data-handle="${item.handle}" data-variant-id="${item.id}"
    >
    ${item.tags.includes("COMINGSOON_BADGE") ? html`<div class="badge rounded-full bg-white-off text-caption font-simon absolute top-3 right-2 px-4 py-2 z-40 uppercase">${theme.strings.badges.comingSoon}</div>` : ''}
    ${item.variants_inventory_count > 0 ? (() => {
      const badgeText = item.tags.includes("NEW_BADGE") ? theme.strings.badges.new :
                        item.tags.includes("RESTOCK_BADGE") ? theme.strings.badges.restock :
                        item.tags.includes("PROPICK_BADGE") ? theme.strings.badges.proPick :
                        item.tags.includes("REVISED_BADGE") ? theme.strings.badges.revised : '';
    
      return badgeText ? html`<div class="badge rounded-full bg-white-off text-caption font-simon absolute top-3 right-2 px-4 py-2 z-40 uppercase">${badgeText}</div>` : '';
    })() : ''}
      <picture class="mb-4 w-full block relative pt-[80%]" style="background-color: ${magColor}">
        <img width="375" height="300" src="${item.image.replace(".jpg","_351x281_crop_center.jpg")}" align="center" data-srcset="${item.image.replace(".jpg","_351x281_crop_center.jpg")} 351w, ${item.image.replace(".jpg","_702x562_crop_center.jpg")} 702w, ${item.image.replace(".jpg","_1053x843_crop_center.jpg")} 1053w, ${item.image.replace(".jpg","_1404x1124_crop_center.jpg")} 1404w" srcset="${item.image.replace(".jpg","_351x281_crop_center.jpg")} 351w, ${item.image.replace(".jpg","_702x562_crop_center.jpg")} 702w, ${item.image.replace(".jpg","_1053x843_crop_center.jpg")} 1053w, ${item.image.replace(".jpg","_1404x1124_crop_center.jpg")} 1404w" data-widths="[351, 702, 1053, 1404]" data-aspectratio="1.25" data-sizes="auto" class="object-contain z-10 px-2 md:px-4 w-full h-full block absolute top-0 left-0 lazyload rounded-t-md" alt=""/>
      </picture>
      <span class="inline-block font-walter text-h6 text-center px-4 mb-0">${item.title} ${components.Highlight({ item, attribute: 'title' })}</span>
      <span class="font-simon text-caption text-center md:mb-2 block mt-0.5 uppercase">
        ${ item.tags.includes('COMING_SOON') ? theme.strings.badges.comingSoon : ((item.product_type == 'Gift Card') || item.variants_inventory_count > 0) ? (shopLocator == 'FR' || getFallbackCountry(shopLocator) =='FR') ? (formatPrice(item.price) +' '+shopCurrency) : (item.meta.filters.rates[shopLocator] == undefined) ? (formatPrice(item.meta.filters.rates[getFallbackCountry(shopLocator)])+' '+shopCurrency) : (formatPrice(item.meta.filters.rates[shopLocator]) +' '+shopCurrency) : theme.strings.soldOut }
      </span>
    </a>
  `
}

let collectionHandle = document.getElementById('hits') ? document.getElementById('hits').getAttribute('data-collection') : '' ;

let productHit = (hit, collectionHandle, hasBadge) => {
  //retrieve badge from metafield
  const badges = [
    // { tag: "ARCHIVE_20250124_FULLPRICE", label: 'TRUE GEM'},
    { tag: "NEW_BADGE", label: theme.strings.badges.new },
    { tag: "RESTOCK_BADGE", label: theme.strings.badges.restock },
    { tag: "PROPICK_BADGE", label: theme.strings.badges.proPick },
    { tag: "COMINGSOON_BADGE", label: theme.strings.badges.comingSoon },
    { tag: "REVISED_BADGE", label: theme.strings.badges.revised }
  ];

  const badge = badges.find(badge => hasBadge !== '1' && hit.tags.includes(badge.tag));

  const badgeHTML = badge ? badge.tag == "COMINGSOON_BADGE" || hit.variants_inventory_count > 0 ? `<div class="rounded-full bg-white-off text-caption font-simon absolute -top-2 right-2 px-4 py-2 z-40 uppercase">${badge.label}</div>` : '' : '';

  const cropCenterSuffix = "_crop_center.jpg";
  const widths = "[351, 702, 1053, 1404]";
  const aspectRatio = "1.25";
  const sizes = "auto";
  const baseClass = "hidden sm:block w-full h-full absolute top-0 left-0 z-0 lazyload border-0";

  const getSrcSet = (img, suffix) => `
    ${img.replace(".jpg", `_351x281${suffix}`)} 351w,
    ${img.replace(".jpg", `_702x562${suffix}`)} 702w,
    ${img.replace(".jpg", `_1053x843${suffix}`)} 1053w,
    ${img.replace(".jpg", `_1404x1124${suffix}`)} 1404w
  `;


  const hoverImg = hit.meta.filters.hover_img ? hit.meta.filters.hover_img : '';


  const hoverImgHTML = `<img src="${hoverImg.replace(".jpg", "_351x281"+cropCenterSuffix)}" align="center" data-srcset="${getSrcSet(hoverImg, cropCenterSuffix)}" data-widths="${widths}" data-aspectratio="${aspectRatio}" data-sizes="${sizes}" class="object-contain ${baseClass}" alt=""/>`;

  const imageHTML = hoverImg !== ''
    ? `<img width="375" height="300" src="${hit.image.replace(".jpg", "_351x281"+cropCenterSuffix)}" align="center" data-srcset="${getSrcSet(hit.image, cropCenterSuffix)}" data-widths="${widths}" data-aspectratio="${aspectRatio}" data-sizes="${sizes}" class="object-contain md:opacity-100 md:hover:opacity-0 z-10 w-full h-full block absolute top-0 left-0 lazyload bg-white transition-all duration-75 border-0" alt=""/>
        ${hoverImgHTML}`
    : `<img width="375" height="300" src="${hit.image.replace(".jpg", "_351x281"+cropCenterSuffix)}" align="center" data-srcset="${getSrcSet(hit.image, cropCenterSuffix)}" data-widths="${widths}" data-aspectratio="${aspectRatio}" data-sizes="${sizes}" class="object-contain md:opacity-100 z-10 w-full h-full block absolute top-0 left-0 lazyload border-0" alt=""/>`;

  //retrieve price from metafield
  const priceHTML = hit.meta.filters.rates
    ? `<p class="block font-simon text-caption md:text-body-d uppercase text-center${isArchive ? ' text-rocky' :''}"">
    ${ hit.tags.includes('COMING_SOON') ? theme.strings.badges.comingSoon : ((hit.product_type == 'Gift Card') || hit.variants_inventory_count > 0 || hit.inventory_quantity > 0)
      ? (shopLocator == 'FR' || getFallbackCountry(shopLocator) =='FR')
        ? isArchive ? hit.variants_compare_at_price_max > 0 ? '<span class="text-rocky mr-3">'+(formatPrice(hit.price)) +' '+shopCurrency+'</span><s class="text-gray-dark">'+(formatPrice(hit.variants_compare_at_price_max)) +' '+shopCurrency+'</s>' : '<span class="text-rocky ml-3">'+(formatPrice(hit.price)) +' '+shopCurrency+'</span>'
        : (formatPrice(hit.price) +' '+shopCurrency) : (hit.meta.filters.rates[shopLocator] == undefined)
          ? (formatPrice(hit.meta.filters.rates[getFallbackCountry(shopLocator)])+' '+shopCurrency)
          : isArchive ? hit.meta.filters.compare_at_rates ? '<span class="text-rocky mr-3">'+(formatPrice(hit.meta.filters.rates[shopLocator]) +' '+shopCurrency)+'</span><s class="text-gray-dark">'+(formatPrice(hit.meta.filters.compare_at_rates[shopLocator]) +' '+shopCurrency)+'</s>' : '<span class="text-rocky mr-3">'+(formatPrice(hit.meta.filters.rates[shopLocator]) +' '+shopCurrency)+'</span>' : (formatPrice(hit.meta.filters.rates[shopLocator]) +' '+shopCurrency)
      : theme.strings.soldOut
    }</p>`
    : '';

  //retrieve swatches from metafield
  const swatchesJson = hit.meta.desc.similar_product_json;
  let swatches;
  try {
    swatches = JSON.parse(swatchesJson);
  } catch (error) {
    console.log('hit', hit)
    console.error('Error parsing JSON:', error);
    return; // Exit the function if there's an error
  }

  // Function to shuffle an array
  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  let swatchX;
  if (swatches.length < 5){
    swatchX = 3;
  }else{
    swatchX = 2;
  }
  
  const shuffledSwatches = shuffleArray([...swatches]); // Create a shuffled copy of the swatches array
  const swatchShow = shuffledSwatches.slice(0, swatches.length); // Select the first 3 elements

  const swatchHTML = swatches !== undefined ? `
    <div class="hit-swatch--list inline-flex flex-wrap gap-2 items-center justify-center w-full mt-3 min-h-[18px] mx-auto max-w-[50%]">
      <div class="hit-swatch--item rounded-full w-3 h-3 block current relative${ hit.meta.filters.color ? hit.meta.filters.color.includes('White') ? ' border border-gray-mid-light' : '' : '' }" title="${hit.title.toUpperCase()} IN  ${hit.meta.color.name.toUpperCase()}">
        ${hit.meta.algolia && hit.meta.algolia.swatch_img ? `<img src='${hit.meta.algolia.swatch_img}' alt="" class="rounded-full h-full w-full">` : `
          <div class="rounded-full h-full w-full" style="background-color: ${hit.meta.color.hex}"></div>`}
      </div>
      ${swatchShow.map((swatch, index) => `
        <a href="${window.Shopify.routes.root}${collectionHandle != '' ? 'collections/'+collectionHandle + '/' : ''}products/${swatch.h}" class="${ index > swatchX ? 'hidden ' : ''}hit-swatch--item rounded-full w-3 h-3 block relative swatch-item hover:opacity-100${ swatch.s.includes('chalk') || swatch.s.includes('white') || swatch.s.includes('neutral') || swatch.s.includes('Ecru') || swatch.c.includes('ECRU') ? ' border border-gray-mid-light': ''}"  data-img="${swatch.i ? swatch.i : ''}" title="${hit.title.toUpperCase()} IN ${swatch.c.toUpperCase()}">
          <img src='${swatch.s}' alt="" class="rounded-full h-full w-full">
        </a>
        ${ swatch.i ? `
          <div class="px-2 md:px-4 absolute top-0 left-0 z-20 hidden hit--swatch-hover-img w-full h-auto">
            <picture class="w-full block pt-[116%] relative">
              <img
                width="375" height="300"
                class="object-contain z-10 w-full h-full block absolute top-0 left-0 lazyload rounded-t-md bg-white lazyload not-hidden"
                alt=""
                src="${swatch.i.replace('.jpg', '_1404x1124_crop_center.jpg')}"
              >
            </picture>
          </div>
        `:''}
      `).join('')}
      ${swatches.length > ( swatchX  + 2 ) ? `<button class="btn-swatch--more block text-12" onclick="showMoreSwatches()">+${swatches.length - swatchX - 1}</button>` : ''}
    </div>
  ` : '';

  

  //return hit template
  return `
    <li class="grid__item mb-10 md:mb-20 relative text-center">
      <a href="${window.Shopify.routes.root}${collectionHandle != '' ? 'collections/'+collectionHandle +'/' : ''}products/${hit.handle}?queryID=${hit.__queryID}" class="hit text-center cursor-pointer hover:opacity-100" data-handle="${hit.handle}" data-variant-id="${hit.id}">
        ${collectionHandle.includes('archive') ? '': badgeHTML}
        <div class="px-2 md:px-4 relative overflow-hidden">
          <picture class="px-2 md:px-4 w-full block relative pt-[116%]">
            ${imageHTML}
          </picture>
        </div>
        <p class="block font-walter text-h6 md:text-h6-d text-center px-4 mt-4 mb-1">${hit.title}</p>
        ${priceHTML}
      </a>
      ${swatchHTML}
      <div class="loader-overlay absolute w-full h-full top-0 right-0 bg-white/50 z-20 items-center justify-center hidden">
        <div class="font-walter text-h1-d">S</div>
      </div>
    </li>
  `;
}

function showMoreSwatches(e){
  const button = event.target;
  const hiddenSwatches = button.parentElement.querySelectorAll('.hit-swatch--item.hidden');
  hiddenSwatches.forEach(swatch => {
    swatch.classList.remove('hidden');
  });
  button.style.display = 'none'; // Hide the button after loading all swatches
}
// QUICK ADD TO BAG
// document.querySelectorAll('.hit-size--list button.in-stock').forEach((button) => {
//   button.addEventListener('click', async (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     let hitElement = button.closest('.hit');
//     let loader = hitElement.parentElement.querySelector('.loader-overlay');
//     loader.classList.remove('hidden');
//     loader.classList.add('flex');
    
//     var vId = button.getAttribute('data-variant');
//     let upsellData = {
//       'items': [{
//         'id': parseFloat(vId),
//         'quantity': 1
//       }]
//     };
//     try {
//       const response = await fetch('/cart/add.js', {
//         method: 'post',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(upsellData)
//       });

//       if (response.ok) {
//         // Get cart count
//         const res = await fetch('/cart.js');
//         const cart = await res.json();

//         updateCartItemCounts(cart.item_count);

//         // Update cart
//         await updateCartDrawer();
//         // Open cart drawer
//         openSideDrawer('side-cart');
//        // Ensure loader is hidden
//        if (loader) {
//         loader.classList.add('hidden');
//         loader.classList.remove('flex');
//       }
//       } else {
//         console.error('Failed to add item to cart:', response.statusText);
//       }
//     } catch (error) {
//       console.error('Error adding item to cart:', error);
//     }
//   });
// });

if(siteHeader){
  shopCurrency = siteHeader.getAttribute('data-variant');
  shopLocator = siteHeader.getAttribute('data-locator');
  shopLocale = siteHeader.getAttribute('data-locale');
}

let countryMatch = {
  FR: ['AL', 'AD', 'AM', 'AT', 'BE', 'BY', 'BA','BG', 'DE', 'ES', 'EE', 'FI', 'HR', 'CZ', 'CY', 'FO', 'GE', 'GI', 'GL', 'GG', 'GR', 'HU', 'IS', 'IE', 'IM', 'IT', 'JE', 'XK', 'LI', 'LT', 'LU', 'LV', 'MK', 'YT', 'MD', 'MT', 'MC', 'ME', 'NL', 'PL', 'PT', 'RE', 'RO', 'SM', 'SK', 'RS', 'SJ', 'SI', 'UA', 'VA', 'GP', 'AX'],
  AI: ['AI', 'AG', 'AW', 'BS', 'BB', 'BZ', 'BM', 'BO', 'BR', 'VG', 'AN', 'KY', 'CO', 'CR', 'CW', 'DM', 'DO', 'EC', 'SV', 'FK', 'PF', 'GD', 'GT', 'GY', 'HT', 'HN', 'JM', 'MQ', 'MS', 'NI', 'PA', 'PY', 'PE', 'MF', 'BL', 'KN', 'LC', 'PM', 'VC', 'SR', 'TT', 'TC', 'UM', 'UY', 'VE'],
  BD: ['AF', 'AZ', 'BD', 'BT', 'IO', 'BN', 'KH', 'CX', 'CC', 'CK', 'FJ', 'PF', 'FQ', 'KZ', 'KI', 'KG', 'LA', 'MO', 'MV', 'MN', 'MM', 'NR', 'NP', 'NC', 'NU', 'NF', 'PK', 'PG', 'PN', 'RU', 'WS', 'SB', 'GS', 'LK', 'TJ', 'TL', 'TK', 'TO', 'TM', 'TV', 'UZ', 'VU', 'VN', 'WF'],
  BH: ['BH', 'EG', 'IQ', 'JO', 'OM', 'PS', 'YE'],
  DZ: ['DZ', 'AO', 'SH', 'BJ', 'BW', 'BF', 'BI', 'CM', 'CV', 'CF', 'TD', 'KM', 'CD', 'CG', 'CI', 'DJ', 'GQ', 'ER', 'SZ', 'ET', 'GA', 'GM', 'GH', 'GN', 'GW', 'KE', 'LS', 'LR', 'LY', 'MG', 'MW', 'ML', 'MR', 'MU', 'MA', 'MZ', 'NA', 'NE', 'NG', 'RW', 'ST', 'SN', 'SC', 'SL', 'SO', 'SS', 'SH', 'SD', 'TZ', 'TG', 'TN', 'UG', 'EH', 'ZM', 'ZW']
}

function getFallbackCountry(e){
  for ( refCountry in countryMatch ){
    countryList = countryMatch[refCountry];
    if (countryList.indexOf(e) != -1){
      return refCountry;
    }
  }
}

function formatPrice(num){
  if(shopLocator == 'NO' || shopLocator == 'DK' || shopLocator == 'ID' || shopLocator == 'QA'){
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }else if (shopLocator == 'SE') {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }else{
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}

const formatP = Intl.NumberFormat(shopLocale+'-'+shopLocator);

const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
  key: 'recent-searches',
  limit: 4,
  transformSource({ source }) {
    return {
      ...source,
      templates: {
        ...source.templates,
        item(params) {
          const { item, html } = params;
          return html`
            <button className="aa-ItemWrapper">
              ${item.label}
            </button>
          `;
        },
      },
      onSelect({ setIsOpen }) {
        setIsOpen(true);
      },
    };
  },
});

function uniqBy(predicate) {
  return function runUniqBy(...rawSources) {
    const sources = rawSources.flat().filter(Boolean);
    const seen = new Set();

    return sources.map((source) => {
      const items = source.getItems().filter((item) => {
        const appliedItem = predicate({ source, item });
        const hasSeen = seen.has(appliedItem);

        seen.add(appliedItem);

        return !hasSeen;
      });

      return {
        ...source,
        getItems() {
          return items;
        },
      };
    });
  };
}

const removeDuplicates = uniqBy(({ source, item }) =>
  source.sourceId === item.label
);

let countryCode = document.querySelector('html').getAttribute('data-country');

let autoFilters = `${archiveTags}`;

// Add conditional filter to hide NEW_BADGE if user is in France
if (countryCode === 'United States') {
  autoFilters += ` AND NOT tags:"EXCLUDEUS"`;
}

autocomplete({
  container: '#autocomplete',
  panelContainer: '#autocompletePanel',
  placeholder: theme.strings.search.autocompletePlaceholder,
  insights: true,
  detachedMediaQuery: 'none',
  plugins: [
    recentSearchesPlugin
  ],
  onSubmit({ state }) {
    closeSearchPanel()
    window.location.href = window.Shopify.routes.root+"search?query="+state.query;
  },
  getSources({ query, setContext }) {
    if (query) {
      return [
        {
          sourceId: 'products',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'shopify_products_autocomplete',
                  query,
                  params: {
                    filters: autoFilters,
                    hitsPerPage: 4,
                  },
                },
              ],
              transformResponse({ results, hits }) {
                setContext({
                  nbProducts: results[0].nbHits,
                });
                return hits;
              },
            });
          },
          onSelect({state}){
            closeSearchPanel();
          },
          templates: {
            item({ html, item, components }) {
              return productItem(html, item, components)
            },
            footer ({ state, html }){
              return html`
                <div class="text-center mb-2.5 sm:mt-8 mt-2 mx-auto w-full">
                  <a
                    href="${window.Shopify.routes.root}search?query=${query}"
                    class="font-walter inline-block text-center bg-black text-white px-8 py-3.5 rounded text-btn"
                  >
                    ${theme.strings.search.seeAllProducts} (${state.context.nbProducts})
                  </a>
                </div>
                `
            },
          },
        },
        {
          sourceId: 'shopByCategory',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'shopify_products',
                  query,
                  params: {
                    hitsPerPage: 0,
                    ruleContexts: ['shop-by-category'],
                  },
                },
              ],
              transformResponse({ results, state }) {
                return results[0].userData[0].items
              },
            });
          },
          onSelect({state}){
            closeSearchPanel();
          },
          templates: {
            item({ html, item }) {
              return html`
                <a
                  class="text-center" href="${window.Shopify.routes.root}${item.href}">
                  <img class="rounded-md" src="${item.image}"/>
                  <span class="font-walter text-sub1 mt-3 block">${theme.strings.product.type[item.title.toLowerCase()]}</span>
                </a>
              `
            },
          },
        },
      ];
    }
  },
  reshape({ sourcesBySourceId }) {
    const {
      recentSearchesPlugin,
      ...rest
    } = sourcesBySourceId;

    return [
      removeDuplicates(recentSearchesPlugin),
      Object.values(rest),
    ];

  },
  render({ elements, render, html, state }, root) {
    const {
      recentSearchesPlugin: recentSearches,
      products,
      shopByCategory,
    } = elements;

    const sourceIdsToExclude = ['recentSearchesPlugin', 'shopByCategory', 'quickAccess'];

    const hasResults =
      state.collections
        .filter(
          ({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1
        )
        .reduce((prev, curr) => prev + curr.items.length, 0) > 0;

    const noResultsMessage = theme.strings.search.noResults.replace('{{ query }}', state.query);

    render(
      html`
      <div class="flex max-sm:flex-wrap">
        <div class="search-panel--left w-full md:w-[35%] pr-6 md:pr-12 max-sm:order-1 max-sm:px-5">
            <div class="search--tips mb-6">
              <p class="font-walter text-h4 md:text-sub1-d mb-3">${theme.strings.search.recentSearch}</p>
              ${recentSearches ? html` <div class="font-simon text-btn2-d "> ${recentSearches}</div>` : html`<p class="text-body3 mb-0 text-gray">${theme.strings.search.noQueryMatch}</p>`}
            </div>
        </div>
        ${state.query && !hasResults
          ? html`
            <div class="search-panel--right w-full mb-6 max-sm:px-5">
              <p class="font-walter text-body3 text-gray">${noResultsMessage}</p>
              <p class="font-walter text-h4 md:text-sub1-d mb-3 mt-4 next-overflow search--by-cat">${theme.strings.search.exploreCategory}</p>
              ${shopByCategory}
            </div>
          `
          :
          html`
            ${state.query && hasResults ?
            html`
              <div class="search-panel--right w-full search--results max-sm:px-5">
                ${products ? html`
                  <div class="mb-9">
                    <p class="font-walter text-h4 md:text-sub1-d mb-3 search--products next-overflow">${theme.strings.search.quickAccess}</p>
                      ${products}
                  </div>
                ` : '' }
              </div>
              ` : ''}
          `
        }
      </div>
      `,
      root
    );
  },
});
